var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"cube-checker-item",class:{'cube-checker-item_active': _vm.isActive, 'cube-checker-item_disabled': _vm.isDisabled},on:{"click":_vm.clickHandler}},[_vm._t("default",function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.option.text)}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }